$(function() {

    $.leader = {};

    $.leader.delayFadeOut = ($("#leader-container").next('section').hasClass('profile-section')) ? false : true;

    $.leader.lastProfile = false;

    // durations

    $.leader.duration = '75%';

    $.leader.calculatePinDuration = function() {
        var contentHeight = $('#leader-container .content-container').outerHeight();
        if ($.leader.lastProfile) {
            $.leader.pinDuration = 0;
        } else {
            $.leader.pinDuration = Math.round(contentHeight + $(window).innerHeight());
        }
        return $.leader.pinDuration;
	};

    $.leader.zoomDuration = '100%';

    $.leader.endDuration = ($.leader.delayFadeOut) ? '150%' : '50%';

    // timelines

    $.leader.tl = {};

    // in

	$.leader.tl.in = new TimelineMax();

    $.leader.tl.in.addLabel("start");

    $.leader.tl.in.set("#leader-container", { visibility: "visible" }, "start");﻿

    if (!$.ms) {

        $.leader.tl.in.from("#leader-svg .line-1", 1, { x:"2560" }, "start");
        $.leader.tl.in.from("#leader-svg .line-2", 1, { x:"2560", delay: 0.25 }, "start");
        $.leader.tl.in.from("#leader-svg .line-3", 1, { x:"2560", delay: 0.5 }, "start");
        $.leader.tl.in.add(function(){ /* pause */ }, "+=0.25");

        new ScrollMagic.Scene({ triggerElement: '#leader-in', triggerHook: 'onEnter', duration: $.leader.duration })
        	.setTween($.leader.tl.in)
        	// .addIndicators({name: 'leader in'})
        	.addTo($.controller);

    }

    // pin

    new ScrollMagic.Scene({ triggerElement: '#leader-pin', triggerHook: 'onLeave', duration: $.leader.calculatePinDuration })
        .setPin('#leader-container .svg-background')
        // .addIndicators({name: 'leader pin'})
        .addTo($.controller);

    // zoom

    $.leader.zoom = {};

    $.leader.tl.zoom = new TimelineMax();

    $.leader.tl.zoom.addLabel("start");
    $.leader.tl.zoom.addLabel("content", 2);

    if ($.ms || ($.windowWidth > $.breakpoint.e3 && $.safari)) { // zoom

        $.leader.tl.zoom.to("#leader-svg .svg-text", 2, { y:"-320" }, "start");

    } else {

        $.leader.zoom.scale = 10;
        $.leader.zoom.offset = $.leader.zoom.scale * 100 / 2;
        $.leader.zoom.xy = "-"+ $.leader.zoom.offset +"%";

        $.leader.tl.zoom.to("#leader-svg .svg-text", 2, { x:$.leader.zoom.xy, y:$.leader.zoom.xy, scaleX:$.leader.zoom.scale, scaleY:$.leader.zoom.scale, force3D:true }, "start");

    }

    $.leader.tl.zoom.to("#leader-container .svg-img-overlay-mask", 0.5, { opacity:0 }, "start");
    $.leader.tl.zoom.to("#leader-background", 0.5, { backgroundColor:$.color.black, delay:1 }, "start");
    $.leader.tl.zoom.fromTo("#leader-svg .svg-img .img-default", 0.5, { opacity:0 }, { opacity:1, delay:1.5 }, "start");
    $.leader.tl.zoom.set("#leader-svg .svg-bg", { visibility:"hidden", delay:2 }, "start");﻿
    $.leader.tl.zoom.set("#leader-svg .svg-img-mask", { visibility:"hidden", delay:2 }, "start");﻿

    $.leader.tl.zoom.fromTo("#leader-container .svg-img-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");
    $.leader.tl.zoom.fromTo("#leader-container .svg-content-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");
    if ($.windowWidth > $.breakpoint.lg) {
        $.leader.tl.zoom.fromTo("#leader-container .svg-content-overlay", 0.5, { x:"-100%" }, { x:"0%" }, "content");
    }
    $.leader.tl.zoom.fromTo("#leader-container .content-container", 0.5, { opacity:0 }, { opacity:1, delay:0.5 }, "content");

    new ScrollMagic.Scene({ triggerElement: '#leader-zoom', triggerHook: 'onCenter', duration: $.leader.zoomDuration })
        .on('start', function () {
            $.leader.tl.in.seek($.leader.tl.in.duration(), false);
        })
        .setTween($.leader.tl.zoom)
        // .addIndicators({name: 'leader zoom'})
        .addTo($.controller);

    $.leader.tl.out = new TimelineMax();

    $.leader.tl.out.addLabel("start");

    $.leader.tl.out.to("#leader-container .content-container", 1, { opacity:0 }, "start");

    if ($.leader.delayFadeOut) {
        $.leader.tl.out.to("#leader-background", 1, { opacity:0, delay:2 }, "start");
    } else {
        $.leader.tl.out.to("#leader-background", 1, { opacity:0 }, "start");
    }

    new ScrollMagic.Scene({ triggerElement: '#leader-end', triggerHook: 'onCenter', duration: $.leader.endDuration })
        .setTween($.leader.tl.out)
        // .addIndicators({name: 'leader out'})
        .addTo($.controller);

});
